import {
    HStack,
    Box,
    Spinner,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
} from '@chakra-ui/react';
import { MentionSpanViewProps, MentionPreviewViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentMentionView(
    config: ReportingViewBaseConfig & {
        MentionPreview: React.FC<MentionPreviewViewProps>;
    }
): React.FC<MentionSpanViewProps> {
    const {
        Container: {
            Content: { Preview: MentionPreviewContainer },
        },
        UI: {
            Application: { Link },
        },
        MentionPreview,
    } = config;

    return (props) => {
        const wrapper = (
            <HStack
                display="inline-flex"
                spacing={1}
                color="whiteAlpha.700"
                fontWeight="medium"
                userSelect="none"
                cursor="pointer"
                px={1}
                py={0.5}
                borderRadius="sm"
                _hover={{
                    bg: 'whiteAlpha.200',
                }}
                position="relative"
            />
        );

        if (props.status === 'loading') {
            return (
                <HStack {...wrapper.props}>
                    <Spinner size="sm" speed="1s" />
                </HStack>
            );
        }
        return (
            <Popover
                trigger="hover"
                openDelay={600}
                closeDelay={0}
                isLazy={true}
                lazyBehavior="unmount"
            >
                <PopoverTrigger>
                    <Box as="span">
                        <HStack {...wrapper.props} as={Link} {...props.link}>
                            {props.icon ? (
                                <Box as="span" position="relative">
                                    {props.icon.text}
                                </Box>
                            ) : null}
                            <Box as="span" textDecor="underline">
                                {props.label}
                            </Box>
                        </HStack>
                    </Box>
                </PopoverTrigger>
                <PopoverContent bg="black" w="16rem">
                    <PopoverBody bg="whiteAlpha.200" p={0} minH="10rem">
                        <MentionPreviewContainer as={MentionPreview} {...props.preview} />
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        );
    };
}
